import { flattenValues } from "@uniformdev/canvas";

export type SlidingLayoutCardColor =
    | "default"
    | "purple"
    | "saffron"
    | "lime"
    | "blue";

export interface UniformSlidingLayoutCard {
    title: string;
    color: SlidingLayoutCardColor;
    icon?: string;
    ctaLinkUrl: string;
    ctaLinkText: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const flattenSlidingLayoutCardProps = (props: any) => {
    return {
        ...props,
        cards: flattenValues(props.cards)
    };
};
